import React from 'react';
import StrokedText from '../../Participation/Nodes/StrokedText';
import ScoreFill from './ScoreFill';
import OrgTreeWeightBadge, {
  ORG_TREE_WEIGHT_ICON_SIZE,
} from './OrgTreeWeightBadge';

const GroupNode = ({
  radius,
  showWeights,
  node: {
    x: y,
    y: x,
    data: { name, score, weight },
  },
}) => {
  const weightTransform = `translate(${radius + 4}, ${-radius / 2})`;

  return (
    <g transform={`translate(${x},${y})`}>
      <ScoreFill radius={radius} score={score} />
      {showWeights ? (
        <OrgTreeWeightBadge
          reverse={false}
          weight={weight}
          transform={weightTransform}
        />
      ) : null}
      <StrokedText
        strokeWidth={3}
        strokeColor="#2c2c2c"
        textAnchor="end"
        fill="#fff"
        x={-(radius + 4)}
        y={0 * (radius / 2)}
        dominantBaseline="middle"
        className="group-name"
        fontSize={10}
      >
        {name}
      </StrokedText>
    </g>
  );
};

export default GroupNode;
